import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Student } from '../model/student.model';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {

  constructor(private http: HttpClient) { }

  ngOnInit(){
    // this.getLatestQuizSessions();
  }

  getLatestQuizSessions(studentId: number): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_QUIZSESSION_ENDPOINT + "?studentId=" + studentId, httpOptions);
  }

  getAllQuizSessions(teacherId: string): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_QUIZSESSION_ENDPOINT + "/allQuizSessions?teacherId=" + teacherId, httpOptions);
  }

  getAllStudents(status: string): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_STUDENT_ENDPOINT + "/byStudentStatus?status=" + status, httpOptions);
  }

  getAllStudentsByStatusAndTeacherId(status: string,teacherId: string): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_STUDENT_ENDPOINT + "/byStudentStatusAndTeacherId?status=" + status + "&teacherId=" + teacherId, httpOptions);
  }

  updateStudentInfo(studentInfo: Student){
    return this.http.put(environment.BACKEND_HOST + environment.BACKEND_STUDENT_ENDPOINT + "/updateStudent", studentInfo)
  }

  getTeacherById(teacherId: string): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_USER_ENDPOINT + "/byTeacherId?teacherId=" + teacherId, httpOptions);
  }

  getLatestStorySessionsByStudentId(teacherId: string): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_STORYSESSION_ENDPOINT + "/getLatestStorySessionsByStudentId?teacherId=" + teacherId, httpOptions);
  }

  fetchLatestStorySessionsByStudentId(studentId: number): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_STORYSESSION_ENDPOINT + "/latestStorySessionsByStudentId?studentId=" + studentId, httpOptions);
  }

  getUserById(userId: string): Observable<any>{
    var httpOptions = {
      headers: new HttpHeaders({ 
        'Access-Control-Allow-Origin':'*'
      })
    }
    return this.http.get(environment.BACKEND_HOST + environment.BACKEND_USER_ENDPOINT + "/byUserId?userId=" + userId, httpOptions);
  }

}
